/**
 * Sino de notificações.
 *
 * O badge é **global** e igual em todas as telas: a contagem de não lidas do
 * usuário, e nunca o resultado do filtro local da Inbox (golden G18). Por isso ele
 * é componente do shell, e não de cada página — a fonte é uma só.
 *
 * A geometria vem do protótipo (18px de altura mínima, anel `ring-paper`): algumas
 * telas do HTML declaram uma variante de 16px, e o `dv-shell.js` diz explicitamente
 * que "o sino é componente do shell, então a medida vem daqui".
 */
import { Icone } from './icone.tsx'
import { Link } from '@tanstack/react-router'
import { useTextos } from '../textos.ts'
import { TEXTOS_DO_SHELL } from './shell-textos.ts'

export function Sino({ naoLidas }: { naoLidas: number }) {
  const texto = useTextos(TEXTOS_DO_SHELL)
  return (
    <Link
      to="/inbox"
      className="relative h-9 w-9 grid place-items-center rounded-[10px] hover:bg-navy/5 text-text2"
      aria-label={texto('notificacoes')}
      title={texto('notificacoes')}
    >
      <Icone nome="bell" className="w-[18px] h-[18px]" />
      {naoLidas > 0 && (
        <span
          data-teste="badge-sino"
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-semibold grid place-items-center ring-2 ring-paper"
        >
          {naoLidas}
        </span>
      )}
    </Link>
  )
}
